import { render, staticRenderFns } from "./PatientRegisterModal.vue?vue&type=template&id=c55a274e&"
import script from "./PatientRegisterModal.vue?vue&type=script&lang=ts&"
export * from "./PatientRegisterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports